import ProfileDropdown from "../../components/ProfileDropdown";

const Header = ({ title }) => {
    return (
        <header className="header tw-z-[49] md:tw-z-10 tw-border-b-1 tw-border-tertiary tw-bg-tertiary tw-text-white tw-flex tw-items-center  ">
            <div className="content-container md:tw-justify-between tw-text-white max-sm:tw-flex max-sm:tw-items-center max-sm:tw-gap-2">
                {/* Mobile layout: Profile + Notification + Title */}
                <div className="sm:tw-hidden tw-flex tw-items-center tw-gap-2 tw-w-full">
                    <ProfileDropdown />
                    <h1 className="tw-flex-1 tw-text-left tw-text-lg tw-font-medium">{title}</h1>
                </div>

                {/* Desktop layout: Title on left, Profile+Notification on right */}
                <div className="max-sm:tw-hidden tw-flex tw-w-full tw-justify-between tw-items-center">
                    <div>
                        <h1 className="tw-min-w-[220px] md:headerText">{title}</h1>
                    </div>
                    <div className="tw-w-[240px] md:tw-w-auto md:tw-flex md:tw-justify-end">
                        <ProfileDropdown />
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
